/* eslint-disable*/
export const poiLegendText = {
  Wohnlage: [],
  ÖPNV: ['Bushaltestelle', 'Bahnstation'],
  Kultur: [
    'Restaurant',
    'Pub',
    'Coffee Shop',
    'Biergarten',
    'Theater',
    'Museum',
    'Kino',
    'Bar',
    'Galerie',
    'Cafe',
    'Nachtclub',
  ],
  Internet: [],
  Nahversorgung: [
    'Supermarkt',
    'Kindergarten',
    'Schule',
    'Drogerie',
    'Apotheke',
    'Krankenhaus',
    'Fitness',
    'Kinderbetreuung',
    'Kiosk',
  ],
};

export const poiLegendTextMappings = {
  Wohnlage: [],
  ÖPNV: ['info-bus_stop', 'info-railway_station'],
  Kultur: [
    'info-restaurant',
    'info-pub',
    'info-coffee_shop',
    'info-biergarten',
    'info-theatre',
    'info-museum',
    'info-cinema',
    'info-bar',
    'info-gallery',
    'info-cafe',
    'info-nightclub',
  ],
  Internet: [],
  Nahversorgung: [
    'info-supermarket',
    'info-kindergarten',
    'info-amenity_school',
    'info-chemist',
    'info-pharmacy',
    'info-hospital',
    'info-fitness',
    'info-childcare',
    'info-c_kiosk',
  ],
};
